import { Card } from '@/components/ui/Card/Card';
import { MODULES, type ModuleId } from '../registry';
import { useSession } from '@/services/auth';
import s from './CardGrid.module.css';

type CardGridProps = {
  onOpen: (id: ModuleId) => void;
};

// Role-aware (ADR-0023 / product-spec §role matrix): ownerOnly modules (Eierseksjon)
// are hidden for ad-hoc + registered guests and shown only to owners/admins. While the
// session probe is in flight the user is treated as a guest, so Eierseksjon stays hidden
// (it never flashes for guests; it appears for owners once the session resolves).
export function CardGrid({ onOpen }: CardGridProps) {
  const { user } = useSession();
  const canSeeOwnerOnly = user?.role === 'owner' || user?.role === 'admin';
  const modules = MODULES.filter((m) => !m.ownerOnly || canSeeOwnerOnly);

  return (
    <div className={s.grid} data-testid="card-grid">
      {modules.map((m) => (
        <Card key={m.id} title={m.title} desc={m.desc} onClick={() => onOpen(m.id)} />
      ))}
    </div>
  );
}
